let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eF7iV")).then(() => parcelRequire('eL3iu'));